import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

// Quietly pings the backend on every route change so we can count public pageviews.
// All admin / login routes are filtered server-side. We also skip them client-side to save a request.
export default function PageTracker() {
  const location = useLocation();
  const lastSent = useRef("");

  useEffect(() => {
    const path = location.pathname || "/";
    if (path.startsWith("/admin") || path.startsWith("/login")) return;
    // Avoid double-firing on the same path (e.g. StrictMode in dev).
    const key = path + location.search;
    if (lastSent.current === key) return;
    lastSent.current = key;

    const referrer = document.referrer || "";
    api
      .post("/track", { path, referrer })
      .catch(() => {
        /* tracking is best-effort */
      });
  }, [location.pathname, location.search]);

  return null;
}
